import { Component, OnInit, Inject, ElementRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { QaNotes } from '../layer-complex/layer-complex.component';

export interface AddExceptionInputData {
	column: { prop: string; name: string; };
	qaNotes: QaNotes;
	record;
}
export interface AddExceptionOutputData {
	exceptions: ExceptionAdd[];
	record: any;
}
export interface ExceptionAdd {
	colName: string;
	colDisplayName: string;
	gqrCode: string;
	desc: string; // Description of the qc error
	reason: string;
	isChecked?: boolean;
	value;
}

@Component({
  selector: 'app-add-exception-modal',
  templateUrl: './add-exception-modal.component.html',
  styleUrls: ['../qc-exceptions/qc-exceptions.component.css', './add-exception-modal.component.css']
})
export class AddExceptionModalComponent implements OnInit, AfterViewInit {

	exceptions: ExceptionAdd[] = [];
	record;

	attributes: {
		name: string;
		prop: string;
		enabled?: boolean;
	}[] = [{
		name: 'Field',
		prop: 'colDisplayName'
	}, {
		name: 'Value',
		prop: 'value'
	}, {
		name: 'QC Code',
		prop: 'gqrCode'
	}, {
		name: 'Reason',
		prop: 'reason',
		enabled: true
	}];
	qaNotesGeomColName: string;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AddExceptionInputData,
		private dialogRef: MatDialogRef<AddExceptionModalComponent>,
		private elemRef: ElementRef,
		private attrIndexService: AttrIndexService
	) { }

	disableAdd() {
		const checked = this.exceptions.find(c => c.isChecked);
		if (!checked) {
			return true;
		}
		const invalid = this.exceptions.find(c => c.isChecked && !c.reason);
		if (invalid) {
			return true;
		}
	}

	cancel() {
		this.dialogRef.close();
	}
	add() {
		const data: AddExceptionOutputData = {
			exceptions: this.exceptions,
			record: this.data.record
		};
		this.dialogRef.close(data);
	}

	ngOnInit() {
		this.qaNotesGeomColName = this.attrIndexService.qaNotesGeomColName;

		this.record = this.data.record;
		const columnQaNotes = this.data.qaNotes[this.data.column.prop];
		const exceptions: ExceptionAdd[] = [];
		columnQaNotes.forEach(i => {
			exceptions.push({
				colName: this.data.column.prop,
				colDisplayName: this.data.column.name,
				gqrCode: i.cd,
				desc: i.msg,
				reason: '',
				isChecked: false,
				value: this.data.record[this.data.column.prop]
			});
		});
		this.exceptions = exceptions;
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.elemRef.nativeElement.querySelector('input.exc-reason').focus();
		});
	}
}
